import { useMemo } from 'react'
import { Banner, BannerVariant } from 'components/common/banner'
import { useCurrentPractice } from '../../../../contexts/PracticeContext'
import { isIndependentPractice, isPaymentsEnabled } from '../../../../util/practice'
import { isEmpty } from 'lodash'
import { activatePracticeRequest } from '../../../../apis/practice'
import toast from 'react-hot-toast'

const PracticeInactiveAccountBanner = () => {
	const { currentPracticeObject, isCurrentPracticeActive } = useCurrentPractice()

	const isSMBPractice = useMemo(
		() => !isEmpty(currentPracticeObject) && isIndependentPractice(currentPracticeObject),
		[currentPracticeObject]
	)

	const isPaymentsClinic = useMemo(
		() => isPaymentsEnabled(currentPracticeObject),
		[currentPracticeObject]
	)

	const onActivatePracticeClick = async () => {
		try {
			await activatePracticeRequest(currentPracticeObject?.id as string)
			toast.success('Account activation requested')
		} catch (error) {
			toast.error('Something went wrong while reactivating your account. Please try again later')
		}
	}

	if (isSMBPractice && isPaymentsClinic && !isCurrentPracticeActive) {
		return (
			<Banner
				title={'Your account is inactive'}
				subtitle={
					'We noticed you stopped taking payments, so we paused your account to keep it safe. To start taking payments again, please reactivate your account.'
				}
				buttonTitle={'Reactivate Account'}
				variant={BannerVariant.ERROR}
				showButton
				showCloseButton={false}
				onButtonClick={onActivatePracticeClick}
			/>
		)
	}
	return null
}

export default PracticeInactiveAccountBanner
